import { createContext, useContext, ReactNode } from "react";
import { getFirmDomain } from "@/shared/utils/firm";
import { HARDCODED_PARAMS, type HardcodedParams } from "@/shared/config/hardcodedParams";

export type { HardcodedParams };

const HardcodedParamsContext = createContext<HardcodedParams>(
  HARDCODED_PARAMS[getFirmDomain()],
);

export function HardcodedParamsProvider({ children }: { children: ReactNode }) {
  return (
    <HardcodedParamsContext.Provider value={HARDCODED_PARAMS[getFirmDomain()]}>
      {children}
    </HardcodedParamsContext.Provider>
  );
}

export function useHardcodedParams(): HardcodedParams {
  return useContext(HardcodedParamsContext);
}
